/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TokensPool,
  TokensPoolInterface,
} from "../../contracts/TokensPool";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "have",
        type: "address",
      },
      {
        internalType: "address",
        name: "want",
        type: "address",
      },
    ],
    name: "OnlyCoordinatorCanFulfill",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "requestId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "randomWord",
        type: "uint256",
      },
    ],
    name: "OracleRequestFulfilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "requestId",
        type: "uint256",
      },
    ],
    name: "OracleRequestSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chance",
        type: "uint256",
      },
    ],
    name: "PrizeCategoryCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chance",
        type: "uint256",
      },
    ],
    name: "PrizeCategoryUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "prizeId",
        type: "uint256",
      },
    ],
    name: "PrizeInCategoryAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
    ],
    name: "PrizeInCategoryFinished",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "prizeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "remaining",
        type: "uint256",
      },
    ],
    name: "PrizeInCategoryWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isERC20",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isERC721",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isERC1155",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PrizeSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isERC20",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isERC721",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isERC1155",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "remaining",
        type: "uint256",
      },
    ],
    name: "addPrizeToCategory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "categoriesLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "chance",
        type: "uint256",
      },
    ],
    name: "createCategory",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "enablePrizeCalculationInOracleResponse",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "enableRequestRandomInOracle",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
    ],
    name: "getCategory",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "prizeId",
        type: "uint256",
      },
    ],
    name: "getCategoryPrize",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isERC20",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isERC721",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isERC1155",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "remaining",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "initialAmount",
            type: "uint256",
          },
        ],
        internalType: "struct TokensPool.Prize",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
    ],
    name: "getCategoryPrizes",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isERC20",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isERC721",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isERC1155",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "remaining",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "initialAmount",
            type: "uint256",
          },
        ],
        internalType: "struct TokensPool.Prize[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
    ],
    name: "getCategoryRemainingPrizes",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isERC20",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isERC721",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isERC1155",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "remaining",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "initialAmount",
            type: "uint256",
          },
        ],
        internalType: "struct TokensPool.Prize[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNonEmptyCategories",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNonEmptyCategoriesWithNFTs",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPrizeFromOracleRandom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "getPrizeFromOracleRandomForUser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalChance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "hasActiveRequest",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "hasPendingRequest",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "coordinator",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "subscriptionId",
        type: "uint64",
      },
      {
        internalType: "bytes32",
        name: "keyHash",
        type: "bytes32",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "isLastRequestReady",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "prizeCategories",
    outputs: [
      {
        internalType: "uint256",
        name: "chance",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isEmpty",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "randomWords",
        type: "uint256[]",
      },
    ],
    name: "rawFulfillRandomWords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "prizeId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "removePrizeInCategory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "requestPrize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "senderRequests",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "senderRequestsCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "gasLimit",
        type: "uint32",
      },
    ],
    name: "updateCallbackGasLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "categoryId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "chance",
        type: "uint256",
      },
    ],
    name: "updateCategoryChance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "kayHash",
        type: "bytes32",
      },
    ],
    name: "updateKeyHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool",
      },
    ],
    name: "updatePrizeCalculationInResponse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "confirmations",
        type: "uint16",
      },
    ],
    name: "updateRequestConfirmations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isEnabled",
        type: "bool",
      },
    ],
    name: "updateRequestRandomInOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "id",
        type: "uint64",
      },
    ],
    name: "updateSubscriptionId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TokensPoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TokensPoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TokensPool__factory extends ContractFactory {
  constructor(...args: TokensPoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<TokensPool> {
    return super.deploy(overrides || {}) as Promise<TokensPool>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TokensPool {
    return super.attach(address) as TokensPool;
  }
  override connect(signer: Signer): TokensPool__factory {
    return super.connect(signer) as TokensPool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokensPoolInterface {
    return new utils.Interface(_abi) as TokensPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokensPool {
    return new Contract(address, _abi, signerOrProvider) as TokensPool;
  }
}
